export default __webpack_public_path__ + "static/media/937.aed98bca.gif";